import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useProductCategories = () => useQuery({ queryKey: ['products-categories'], queryFn: async () => {
    const callback = await API.get(`/common/products/categories`)
    return callback?.data
}})

export default useProductCategories